// extracted by mini-css-extract-plugin
export default {"OperationsHeader":"operations-header_OperationsHeader__svhL5","OperationsHeader__links":"operations-header_OperationsHeader__links__ZwQQs"};